import { Component, ViewChild,Input, OnDestroy,Output, EventEmitter, effect, inject, ViewChildren, QueryList, ElementRef, ChangeDetectorRef, HostListener } from '@angular/core';
import { CdkDragDrop, CdkDropList, CdkDrag, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatTable, MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { BudgetGenerateService } from '@services/budget-generate.service';
import { NgbModal, NgbModalRef, NgbModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import { UserService } from '@services/core/user.service';
import { Entity } from '@model/entity.model';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { ContextMenuComponent } from 'app/components/contex-menu/context-menu.component';
import { FilterModel } from './filter.model';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core'; 
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { PermissionService } from '@services/core/permission.service';
import { FormulaRefService } from '@modules/setting/formula-ref/formula-ref.service';


@Component({
  selector: 'app-setting-field-salary-calculated',
  templateUrl: 'setting-field-salary-calculated.component.html',
  styleUrl: 'setting-field-salary-calculated.component.css',
  standalone: true,
  imports: [CdkDropList,
    CdkDrag,
    MatTableModule,
    MatIconModule,
    MatRippleModule,
    MatCheckboxModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    ContextMenuComponent, CommonModule,
    MonacoEditorModule, NgbTooltip],
  providers: [NgbModal],
})
export class SettingFieldSalaryCalculatedComponent implements OnDestroy {
  @Input() employeeType!: number;
  @Input() version!: number;
  @Input() year!: number;
  @Input() budgetEmployeeType!: any[];
  @Input() fundSelected
  @Output() activeChange = new EventEmitter<boolean>();
  @ViewChild('table', { static: true }) table: MatTable<any>;
  @ViewChildren('input') inputs!: QueryList<ElementRef>;
  @ViewChild('modal_account', { static: true }) modalAccount: any;
  @ViewChild('nameInput') nameInput: ElementRef;
  @ViewChild('ngSelect', { static: false }) ngSelectAssinet: NgSelectComponent;
  @ViewChild(ContextMenuComponent) contextMenu!: ContextMenuComponent;
  private modalRef: NgbModalRef;
  public filter: FilterModel = new FilterModel();
  public budgetGenerateService = inject(BudgetGenerateService);
  private formulaRefService = inject(FormulaRefService);
  private _identityService = inject(UserService);
  private entitySelected: Entity;
  public itemsTravel:{ [key: string]: any[] } = {};
  public apsEmployeeValue:{ [key: string]: any[] } = {};
  private timeout: any;
  public dataSource;
  public formItemsTravel: FormGroup;
  public appHasAccess: string[] = [];
  public account;
  public id;
  editorOptions = {
    theme: 'vs-light',
    language: 'formulaLang',
    automaticLayout: true,
    minimap: { enabled: false },
    hover: {
      enabled: true,
      above: false 
    }
  };
 budgetFactor;
 variablesMap;
 variablesMapTemp;
 private hoverDisposable: any;
 private completionDisposable: any;
 role;
 theme
 monacoInitialized = false;
 formulaEditing=false;
  displayedColumns: string[] = [
    'order',
    'apsCode',
    'name',
    'decimalPlaces',
    'hint',    
    'accountCode',
    'calculation',
    'syncAps',
    'includeInTotal',
    'block',
    'setting'];
  constructor(private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private permissionService: PermissionService
  ) {

    effect(() => {
      this.entitySelected = this._identityService.sharingEntity();
      this.role = this._identityService.sharingRole();
      if (this.entitySelected && Object.keys(this.entitySelected).length > 0) {
        this.getFormula();      
        this.formItemsTravel.get('entityCode').patchValue(this.entitySelected?.code);
      }

    })


  }


  /**crear formulario reactivo diverso*/
  createFormAccount() {
    this.formItemsTravel = this.formBuilder.group({
      code: [undefined, [Validators.minLength(1)]],
      name: ['', [Validators.required, Validators.minLength(3)]],
      hint: [''],
      calculation: [''],
      accountCode: [''],
      fundCode: ['', [Validators.required]],
      categoryCode: ['1', [Validators.required]],
      entityCode: ['', [Validators.required, Validators.minLength(1)]],
      employeeType: ['', [Validators.required]],
      year: ['', [Validators.required]],
      version: ['', [Validators.required]],
      isEditable: [true],
    });
  }



 /**Activa el input y le da el foco */
 enableEditing(element, field) {
  if(element.isEditable){
   
  element['isEditing' + field] = true;
  this.cdr.detectChanges();
  setTimeout(() => {
    const input = this.inputs.toArray()[0];
    if (input && input.nativeElement) {
      input.nativeElement.focus();
    }
  }, 0);
  }
}


  /**Ajusta el alto de scroll y la posicion de del input en relacion a la posicion del contenedor */
  autoGrow(event: Event): void {
    clearTimeout(this.timeout);
    const textArea = event.target as HTMLTextAreaElement;
    const parent = textArea.parentElement;
    const topParent = parent.getBoundingClientRect()
    const newTop = topParent.top - 16;
    textArea.style.height = textArea.scrollHeight + 2 + 'px';
    textArea.style.top = newTop + 'px';
    textArea.style.left = topParent.left + 'px';
  }

  /*get Factore*/

  getFormula(){
    this.budgetGenerateService.getBudgetFactors({      
      year: this.year,
      version: this.version,
    }).subscribe(res => {
      this.budgetFactor = res;
      this.variablesMap = this.budgetFactor.reduce((acc, factor) => {
        acc[factor.code] = factor.name;
        return acc;
      }, {});
        this.variablesMap[1] = 'Puntaje Empleado';
      this.variablesMap[2] = 'Carga Infantil';
      this.getItemsAccount();
    })
  }

  /**Ajusta el alto y la posicion de del input a la posicion del contenedor */
  autoTop(event: Event): void {
    clearTimeout(this.timeout);
    const textArea = event.target as HTMLTextAreaElement;
    const parent = textArea.parentElement;
    const topParent = parent.getBoundingClientRect()
    const newTop = topParent.top - 16;
    textArea.style.height = 55 + 'px';
    textArea.style.top = newTop + 'px';
  }


  /**mueve la fila y ejecuta el metodo para actualizar el nuevo orden */
  drop(event: CdkDragDrop<string>) {
    const previousIndex = this.dataSource.findIndex(d => d === event.item.data);
    moveItemInArray(this.dataSource, previousIndex, event.currentIndex);
    this.updateOrder(this.dataSource)
    this.table?.renderRows();
    this.notification('Datos Actualizados');
  }


  getAccountPlanWithTime() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.getItemsAccount();
    }, 5000);
  }

  /**Metodo para actualizar el orden del plan de cuenta */
  updateOrder(data) {
    const bulkUpdates = data.map((account, index) => {
      return { id: account.id, order: index + 1 };
    })
    this.budgetGenerateService.updateSalaryCalculatedItemsBulk(bulkUpdates).subscribe(res => {
      this.getItemsAccount();
    })
  }


  setAccount(id: string) {
    return this.dataSource.find(acc => acc.id == id);
  }


  /**Actualiza el items travel*/
  updateItemsAccount(data, field, newValue) {
    clearTimeout(this.timeout);
    let account = this.setAccount(data.id)
    if (account[field] != newValue) {
      account[field] = newValue
      this.budgetGenerateService.updateSalaryCalculatedItems({ id: data.id, [field]: newValue }).subscribe(res => {
        account.isEditingCal = false;
        this.notification('Datos Actualizados');
      })
    }
  }


   


  /**Elimina un items de travel*/
  deleteItemsAccount(params) {
    Swal.fire({
      icon: 'warning',
      title: 'Alerta ',
      text: '¿Desea eliminar el item de calculo ' + params.code + ' ' + params.name + '?',
      toast: false,
      position: 'center',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      timer: null,
      timerProgressBar: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.budgetGenerateService.deleteSalaryCalculatedItems({ id: params.id }).subscribe(res => {
          this.notification('Item de calculo ' + params.code + ' ' + params.name + 'eliminada ');
          this.getItemsAccount();
        })

      }
    })



  }

  syncEmployee(data, field, newValue){
     if(newValue){
      Swal.fire({
            icon: 'warning',
            title: 'Alerta ',
            text: '¿Desea sincronizar los valores de APS? se actualizaran la cuenta ' + data.accountCode + ' ' + data.name + ' con los datos APS' ,
            toast: false,
            position: 'center',
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            timer: null,
            timerProgressBar: false
          }).then((result) => {
            if (result.isConfirmed) {
              this.updateItems(data, field, newValue)
            }
            else{
                data[field] = false;
            }
          }
        )
        }
        else{
          this.updateItems(data, field, newValue)
        }
    }

    updateItems(data, field, newValue){
      this.budgetGenerateService.updateSalaryCalculatedItems({ id: data.id, [field]: newValue }).subscribe(res => {
     this.notification('Datos Actualizados');
  })
    }

  ngOnInit() {
    /**aqui podemos recibir los valores desde la tabla budget_version */
    this.filter.year = this.year;
    this.filter.version = this.version;
    this.theme=localStorage['appDarkMode'] ? 'vs-dark' : 'vs-light'
   this.createFormAccount();
    this.formItemsTravel.get('year').patchValue(this.filter.year);
    this.formItemsTravel.get('version').patchValue(this.filter.version);
    this.formItemsTravel.get('employeeType').patchValue(this.employeeType);    
    this.formItemsTravel.get('fundCode').patchValue(this.fundSelected); 
    this.appHasAccess = this.permissionService.appHasAccess; 
  }


  openModalFormulaEditing(params) {
    if(params.isEditable){
    this.formItemsTravel.patchValue(params)   
    this.formItemsTravel.get('calculation').setValue(
      this.formatFormula(params.calculation)
    );
     
    this.id = params.id;
    this.formulaEditing=true;
  }
  }


  
  hover(monaco) {
    this.hoverDisposable =monaco.languages.registerHoverProvider('formulaLang', {
      provideHover: (model, position) => {
        const lineContent = model.getLineContent(position.lineNumber);
        const regex = /\{([a-zA-Z0-9_]+)\}/g;
        let match;
        let hover=null;

        while ((match = regex.exec(lineContent)) !== null) {
          const [full, key] = match;
          const start = match.index + 1;
          const end = start + key.length;

          if (position.column >= start && position.column <= end + 1) {
            const desc = this.variablesMap[key];
            if (desc) {
              hover = {
                range: new monaco.Range(
                  position.lineNumber,
                  start,
                  position.lineNumber,
                  end + 1
                ),
                contents: [{ value: `**${desc}**` }]
              };
            }
          }
        }

        return hover;
      }
    });
  }


  autoComplete(monaco) {
    this.completionDisposable =monaco.languages.registerCompletionItemProvider('formulaLang', {
      triggerCharacters: ['{'],
      provideCompletionItems: () => {
        const suggestions = Object.keys(this.variablesMap).map(key => ({
          label: `{${key}}`,
          kind: monaco.languages.CompletionItemKind.Variable,
          insertText: `${key}}`,
          detail: this.variablesMap[key]|| 'Descripción no disponible'
        }));
        return { suggestions };
      }
    });

  }

  
  
 onMonacoInit() {
  const monaco = (window as any).monaco;
  if (!monaco) return;

  if (!this.monacoInitialized) {
    monaco.languages.register({ id: 'formulaLang' });
    
    monaco.languages.setMonarchTokensProvider('formulaLang', {
      tokenizer: {
        root: [
          [/\{[a-zA-Z0-9_]+\}/, 'variable'],
          [/if|;/, 'keyword'],
          [/[0-9]+/, 'number'],
          [/[\+\-\*\/\(\)]/, 'operator']
        ]
      }
    });

    this.hover(monaco);
    this.autoComplete(monaco);  
    monaco.editor.setTheme(this.theme);
    this.monacoInitialized = true; // marca que ya inicializamos
  }
}

ngOnDestroy() {
  if (this.hoverDisposable) {
    this.hoverDisposable.dispose();
    this.hoverDisposable = null;
  }
  if (this.completionDisposable) {
    this.completionDisposable.dispose();
    this.completionDisposable = null;
  }
}


    /**al cerrar el ngselect le pasa el foco y el valor al input de displayName */
    submitEditItems() {
      if (this.formItemsTravel.valid) {
        let data = this.formItemsTravel.value;
        data.id = this.id;
       this.budgetGenerateService.updateSalaryCalculatedItems(data).subscribe(res => {
        let account = this.setAccount(data.id)
        account.calculation = data.calculation;
        this.formulaEditing=false;      
         this.resetForm();
         this.close();
         this.notification('Item guardado exitosamente');
       })
     }
   }

formatFormula(code: string): string {
  if (!code) return '';
  return code
    .replace(/;/g, ';\n')
    .replace(/\(/g, '(\n  ')
    .replace(/\)/g, '\n)')
    .replace(/\+/g, ' + ')
    .replace(/\*/g, ' * ')
    .replace(/\//g, ' / ');
}








  /**formula-ref.Edición Campo indica si el concepto se puede editar en este mantenedor local*/
  applyFormulaRefEditability(items, refs) {
    const refByKey = new Map<string, any>(
      (refs || []).map((ref) => [`${ref.employeeType}_${ref.code}`, ref])
    );
    (items || []).forEach((item) => {
      const ref = refByKey.get(`${item.employeeType}_${item.code}`);
      if (ref) {
        item.isEditable = !!ref.isEditable;
        if (!item.apsCode && ref.apsCode) {
          item.apsCode = ref.apsCode;
        }
      } else {
        item.isEditable = true;
      }
    });
    return items;
  }

  setItemsAccount(res) {
    this.budgetEmployeeType.forEach(element => {
      this.itemsTravel[element.employeeType] = res.filter(r => r.employeeType == element.employeeType && r.fundCode==this.fundSelected);
    });
    this.dataSource = this.itemsTravel[this.employeeType];
    let hover = (this.dataSource || []).reduce((acc, item) => {
      acc[item.code] = item.name;
      return acc;
    }, {});
    this.variablesMap = { ...hover,...this.variablesMap};
    this.getApsEmployeeValue();
  }

  /**trae el plan de cuentas */
  getItemsAccount() {
    delete this.filter.typeId;
    this.budgetGenerateService.getSalaryCalculatedItems(this.filter).subscribe(res => {
      this.formulaRefService.getFormulaRef().subscribe({
        next: (refs) => this.setItemsAccount(this.applyFormulaRefEditability(res, refs)),
        error: () => this.setItemsAccount(res)
      });
    })
  }

  getApsEmployeeValue() {
    this.budgetGenerateService.getApsEmployeeValue(this.filter).subscribe(res => {
       this.budgetEmployeeType.forEach(element => {
        this.apsEmployeeValue[element.employeeType] = res.filter(r => r.employeeType == element.employeeType && r.fundCode==this.fundSelected);
      })
      let dataSource = this.apsEmployeeValue[this.employeeType];
      let hover = dataSource.reduce((acc, item) => {
        acc[item.itemCode] = item.itemName;
        return acc;
      }, {});
      this.variablesMap = { ...hover,...this.variablesMap};

    })
  }



  /*abre los modales */
  open(content, size?) {
    this.modalRef = this.modalService.open(content, size);
  }

  /*cierra los modales */
  close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  /**abre el modal de agregar cuenta */
  openModalAccount() {
    this.open(this.modalAccount)
  }

  changeEmployeeType() {
    this.dataSource = this.itemsTravel[this.employeeType];
    this.formItemsTravel.get('employeeType').patchValue(this.employeeType);
  }

  /**busca los las cuentas q no existen  */
  findAcountPlan(code): boolean {
    let r = false;
    try {
      r = !this.itemsTravel[this.employeeType].some((a) => a.accountCode == code);
    }
    catch {
    }
    return r
  }


  /**busca los las cuentas q existen  */
  findAcount(code): boolean {
    return this.dataSource.some((a) => a.accountCode == code);
  }



  /*mapea los datos del ng-select deshabilita los registros q ya entan registrado el diverso de empleado */
  mapSelect(data) {
    let newData = data.map((d) => {
      const name = d.name
      const isActive = this.findAcountPlan(d.code)
      return {
        code: d.code,
        nameCode: d.code + ' - ' + name,
        name: name,
        disabled: !isActive,
        isActive: isActive
      }
    });
    return newData
  }


  resetForm() {
    this.formItemsTravel.patchValue({
      accountCode: undefined,
      name: undefined,
      hint: '',
      calculation: ''
    });
    this.formItemsTravel.get('code')?.markAsPristine();
    this.formItemsTravel.get('accountCode')?.markAsPristine();
    this.formItemsTravel.get('name')?.markAsPristine();
    this.formItemsTravel.get('hint')?.markAsPristine();
    this.formItemsTravel.get('calculation')?.markAsPristine();
    this.formItemsTravel.get('name')?.markAsUntouched();
 if (this.hoverDisposable) {
    this.hoverDisposable.dispose();
    this.hoverDisposable = null;
  }
  if (this.completionDisposable) {
    this.completionDisposable.dispose();
    this.completionDisposable = null;
  }

  }




  /**al cerrar el ngselect le pasa el foco y el valor al input de displayName */
  submitNewItems() {
     if (this.formItemsTravel.valid) {

      this.budgetGenerateService.saveSalaryCalculatedItems(this.formItemsTravel.value).subscribe(res => {
        this.getItemsAccount();
        this.close();
        this.resetForm();
        this.notification('Item guardado exitosamente');
      })
    }
  }


  notification(title) {
    const Toast = Swal.mixin({
      icon: 'success',
      title: title,
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 2500,
      timerProgressBar: true,
    });
    Toast.fire();
  }



}


